import setupParallax from '@/utils/setupParallax';

export default function(dom, opts) {
	let options = {
		baseClass: 'stickyleadtext',
		...opts
	};

	const shapes = Array.from(dom.querySelectorAll(`.${options.baseClass}__shape`));
	const fullRotation = 90;

	const updateShaperotation = ({factor, factorReversed}) => {
		for (let i in shapes) {
			shapes[i].style.transform = `scale(1) rotateZ(${factor * fullRotation}deg)`;
		}
	};

	setupParallax(dom, updateShaperotation);
}
